<template>
  <b-container fluid>
    <b-row class="mb-4">
      <b-col sm="8">
        <h3>
          <b-badge variant="primary">
            Additional Details: Household
          </b-badge>
          <b-spinner small v-if="waiting" class="align-middle"></b-spinner>
        </h3>
      </b-col>
      <b-col>
        <b-button 
          block
          @click="$router.go(-1)">
          Back
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div v-if="Object.keys(item).length > 0">
          <b-row v-for="(field, index) in fields" :key="index">
            <b-col :class="{ odd: (index % 2 == 0) }">
              <strong>{{ field.label }}</strong>
            </b-col>
            <b-col :class="{ odd: (index % 2 == 0) }">
              {{ item[field.key] }}
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-row class="pt-4">
      <b-col>
        <h3>Roster Questionnaire Outcome</h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          small
          responsive
          stacked="sm"
          :busy="waiting"
          :items="rosterTableItem"
          :fields="rosterTableFields">
        </b-table>
      </b-col>
    </b-row>
    <b-row class="pt-4">
      <b-col>
        <h3>Household Questionnaire Outcome</h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          small
          responsive
          stacked="sm"
          :busy="waiting"
          :items="householdTableItem"
          :fields="householdTableFields">
        </b-table>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { apiService } from '../_services'

export default {
  name: 'HouseholdDetails',
  data() {
    return {
      waiting: false,
      HHID: '',
      item: {},
      fields: [
        {
          key: 'ClaimID',
          label: 'Claim ID'
        },
        {
          key: 'HHID',
          label: 'HHID'
        },
        {
          key: 'PID',
          label: 'PID'
        },
        {
          key: 'RespondentFirstName',
          label: 'Respondent First Name'
        },
        {
          key: 'RespondentLastName',
          label: 'Respondent Last Name'
        },
        {
          key: 'CellphoneNumber',
          label: 'Cellphone Number'
        },
        {
          key: 'TelephoneNumber',
          label: 'Telephone Number'
        },
        {
          key: 'ApproximateAgeofRespondent',
          label: 'Approximate Age of Respondent'
        },
        {
          key: 'GenderofRespondent',
          label: 'Gender of Respondent'
        },
      ],
      rosterTableItem: [],
      rosterTableFields: [
        {
          key: 'DateROS',
          label: 'Date'
        },
        {
          key: 'RosterQuestionaireOutcome',
          label: 'Outcome'
        },
        {
          key: 'AdditionalDetailsROS',
          label: 'Additional Details'
        },
        {
          key: 'ReasonForRefusalROS',
          label: 'Reason for Refusal'
        },
      ],
      householdTableItem: [],
      householdTableFields: [
        {
          key: 'DateHH',
          label: 'Date'
        },
        {
          key: 'HouseholdQuestionnaireOutcome',
          label: 'Outcome'
        },
        {
          key: 'AdditionalDetailsHH',
          label: 'Additional Details'
        },
        {
          key: 'ReasonForRefusalHH',
          label: 'Reason for Refusal'
        },
      ]
    }
  },
  created() {
    let vm = this
    this.HHID = this.$route.params.hhid
    this.waiting = true
    apiService.getHouseholdDetails(this.HHID)
    .then((response) => {
      vm.item = response.data
      vm.rosterTableItem = [{
        DateROS: response.data.DateROS,
        RosterQuestionaireOutcome: response.data.RosterQuestionaireOutcome,
        AdditionalDetailsROS: response.data.AdditionalDetailsROS,
        ReasonForRefusalROS: response.data.ReasonForRefusalROS,
      }]
      vm.householdTableItem = [{
        DateHH: response.data.DateHH,
        HouseholdQuestionnaireOutcome: response.data.HouseholdQuestionnaireOutcome,
        AdditionalDetailsHH: response.data.AdditionalDetailsHH,
        ReasonForRefusalHH: response.data.ReasonForRefusalHH,
      }]
      vm.waiting = false
    })
  }
}
</script>

<style scoped>

</style>
ClaimID
HHID
PID
RespondentFirstName
RespondentLastName
CellphoneNumber
TelephoneNumber
ApproximateAgeofRespondent
GenderofRespondent

DateROS
RosterQuestionaireOutcome
AdditionalDetailsROS
ReasonForRefusalROS

DateHH
HouseholdQuestionnaireOutcome
AdditionalDetailsHH
ReasonForRefusalHH


// WEBPACK FOOTER //
// src/components/HouseholdDetailsPage.vue